import { createReducer } from 'redux-act';
import * as actions from '#app/actions/repo';
import type { RepoFormPayload, RepoCloseFormPayload } from '#app/actions/repo';

interface RepoState {
  modalVisible: boolean;
  form: Record<string, unknown>;
  closeModalVisible: boolean;
  closeForm: Record<string, unknown>;
}

const initialState: RepoState = {
  modalVisible: false,
  form: {},
  closeModalVisible: false,
  closeForm: {},
};

const setRepoModalVisible = (state: RepoState, bool: boolean): RepoState => {
  // console.log('[reducer/repo] setRepoModalVisible вызван - устанавливается modalVisible:', bool);
  return {
    ...state,
    modalVisible: bool,
  };
};

const closeRepoForm = (state: RepoState): RepoState => ({
  ...state,
  form: {},
  modalVisible: false,
});

const setRepoForm = (state: RepoState, form: RepoFormPayload): RepoState => {
  // console.log(
  //   '[reducer/repo] setRepoForm вызван - устанавливается modalVisible: true',
  //   (form as { id?: unknown })?.id || 'новый REPO'
  // );
  return {
    ...state,
    form: form,
    modalVisible: true,
  };
};

const setRepoCloseModalVisible = (state: RepoState, bool: boolean): RepoState => {
  // console.log(
  //   '[reducer/repo] setRepoCloseModalVisible вызван - устанавливается closeModalVisible:',
  //   bool
  // );
  return {
    ...state,
    closeModalVisible: bool,
  };
};

const closeRepoCloseForm = (state: RepoState): RepoState => ({
  ...state,
  closeForm: {},
  closeModalVisible: false,
});

const setRepoCloseForm = (state: RepoState, form: RepoCloseFormPayload): RepoState => {
  // console.log(
  //   '[reducer/repo] setRepoCloseForm вызван - устанавливается closeModalVisible: true',
  //   (form as { id?: unknown })?.id || 'новый'
  // );
  return {
    ...state,
    closeForm: form,
    closeModalVisible: true,
  };
};

export default createReducer<RepoState>(
  {
    [actions.setRepoModalVisible.getType()]: setRepoModalVisible,
    [actions.setRepoForm.getType()]: setRepoForm,
    [actions.closeRepoForm.getType()]: closeRepoForm,
    [actions.setRepoCloseModalVisible.getType()]: setRepoCloseModalVisible,
    [actions.setRepoCloseForm.getType()]: setRepoCloseForm,
    [actions.closeRepoCloseForm.getType()]: closeRepoCloseForm,
  },
  initialState
);
